module.exports = __webpack_public_path__ + "img/zy-yy.c71e4f3b.png";